import {
    defaultCreateHTML,
    defaultCreateScript,
    defaultCreateScriptUrl,
} from './defaultTrustedTypesPolicy';
import { isBootFeatureEnabled } from 'owa-metatags';

export function addDefaultTrustedTypesToWindow(targetWindow: Window): void {
    const isTrustedTypesEnabled = isBootFeatureEnabled('fwk-enforce-trusted-types');

    if (targetWindow.trustedTypes && targetWindow.trustedTypes.defaultPolicy === null) {
        targetWindow.trustedTypes.createPolicy('default', {
            createHTML: (html: string, type: string, sink: string) =>
                defaultCreateHTML(html, type, sink, isTrustedTypesEnabled),
            createScriptURL: (url: string, type: string, sink: string) =>
                defaultCreateScriptUrl(url, type, sink, isTrustedTypesEnabled),
            createScript: (script: string, type: string, sink: string) =>
                defaultCreateScript(script, type, sink, isTrustedTypesEnabled),
        });
    }
}
